const cleanLocalAndSessionStorage = ({
  localStorageKeys = [],
  sessionStorageKeys = []
}: {
  localStorageKeys?: string[]
  sessionStorageKeys?: string[]
}) => {
  Object.keys(localStorage).forEach(key => {
    if (localStorageKeys.find(item => key.includes(item))) {
      localStorage.removeItem(key)
    }
  })

  Object.keys(sessionStorage).forEach(key => {
    if (sessionStorageKeys.find(item => key.includes(item))) {
      sessionStorage.removeItem(key)
    }
  })
}

export default cleanLocalAndSessionStorage
